module.exports = __webpack_public_path__ + "img/43.7b353c84.jpg";